import React from 'react';
import { EntityDetailFetcher } from '../components/EntityDetailFetcher';
import typeIntro from '../static/introspection/Good360.json';
import { ENTITY } from '../utils/entities';
import { Good360DetailQuery } from 'graphql/query/Good360DetailQuery';
import { Entity360Actions } from '../components/Entity360Actions';
import { StatusSetter } from '../components/StatusSetter';
import { setGood360StatusMutation } from '../graphql/mutations/setGood360StatusMutation';
import Status360Introspection from '../static/introspection/Status360.json';
import { t } from '../utils/labels';
import { transformerHandler } from '../utils/misc';
import { fastTransformer } from '../utils/form';
import { relation360AdvsTab } from '../components/relation360AdvsTab';

const statuses = Status360Introspection.enumValues.map((o) => o.name);

export const Good360Detail = ({ id }) => (
	<EntityDetailFetcher
		id={id}
		query={Good360DetailQuery}
		entityName={ENTITY.GOOD_360}
		typeIntro={typeIntro}
		clonable={false}
		forcedPermissions={{ canEdit: false }}
		customActionComponents={(entity) => [
			<StatusSetter
				key="status"
				statuses={statuses}
				entityName={ENTITY.GOOD_360}
				entity={entity}
				statusFieldName="status"
				mutation={setGood360StatusMutation}
				entityIntrospection={typeIntro}
			/>,
			<Entity360Actions
				key="actions"
				entity={entity}
				entityName={ENTITY.GOOD_360}
			/>,
		]}
		fields={['status', 'Good', 'Relation360_Advs']}
		transformer={transformerHandler(
			fastTransformer({
				// stessa cartella ADV di Company360: elenco in sola lettura + "Imposta Stato"
				Relation360_Advs: relation360AdvsTab(1),
			}),
		)}
		tabs={[t('generic data'), t(['Good360', 'Advs', 'label'].join('/'))]}
		cols={[['col-sm-12'], ['col-sm-12']]}
	/>
);